import React from 'react';
import { SVGProps } from 'react';
import { clsx } from 'clsx';
import { IconProps, iconVariants } from '../icon';
import '../icon/icon.module.scss';
type Props = IconProps & Omit<SVGProps<SVGSVGElement>, keyof IconProps>;
const ChevronDown = React.forwardRef<SVGSVGElement, Props>(({ color, size, opacity = 1, className, ...props }, ref) => {
  const classes = clsx(
    iconVariants({
      color,
      size,
    }),
    className,
  );
  const style: React.CSSProperties = {
    '--opacity': opacity,
  };
  return React.cloneElement(
    <svg xmlns="http://www.w3.org/2000/svg" width={13} height={9} fill="none" viewBox="0 0 13 9" ref={ref} {...props}>
      <path
        fill="currentColor"
        d="M6.455 5.188 10.781.86 12.22 2.3 6.455 8.062.691 2.3 2.13.86z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>,
    {
      role: 'presentation',
      focusable: false,
      className: classes,
      'aria-hidden': true,
      style,
      ...props,
    },
  );
});
ChevronDown.displayName = 'ChevronDown';
export default ChevronDown;
